<template lang="pug">
	div.contenedor
		.titulo
			div.bg-dark.text-white.p-1
				span.fa.fa-star.mr-2
				| Favoritos
		arbol-favoritos.arbol(
			v-if="listadoBuzones.length > 0"
			:listado="listadoBuzones"
			:nivel="0"
			@contextmenu.native="menuContextualArbol"
		)
		div.arbol.text-center.p-3.text-danger(v-if="listadoBuzones.length === 0", @contextmenu="menuContextualArbol")
			h3 No tienes buzones
			h4
				small Haz click derecho para crear uno
		ficheros-favoritos.ficheros(
			v-if="buzonActivo"
			:buzon="buzonActivo"
			@insertar="insertar"
			@reproducir="reproducir"
		)

		editor-buzones(
			v-if="editarBuzon"
			:padre="editarBuzon.padre"
			:buzon="editarBuzon.buzon"
			@cerrar="editarBuzon = null"
			@guardado="getListado"
		)
</template>

<script>
import ArbolFavoritos from './arbol-favoritos.vue'
import EditorBuzones from './editor-favoritos.vue'
import FicherosFavoritos from './ficheros-favoritos.vue'
import { mapGetters } from 'vuex'
export default {
	components: {
		'arbol-favoritos': ArbolFavoritos,
		'editor-buzones': EditorBuzones,
		'ficheros-favoritos': FicherosFavoritos
	},
	data () {
		return {
			editarBuzon: null
		}
	},
	created () {
		this.$store.dispatch('organizar-emisoras/getBuzonesFavoritos')
	},
	computed: {
		...mapGetters({
			'listadoBuzones': 'organizar-emisoras/buzonesFavoritos',
			'listadoItems': 'organizar-emisoras/ficherosFavoritos',
			'buzonActivo': 'organizar-emisoras/buzonActivoFavoritos'
		})
	},
	methods: {
		menuContextualArbol (e) {
			e.preventDefault()
			e.stopPropagation()
			const menu = {
				titulo: 'Favoritos',
				evento: e,
				items: []
			}

			menu.items.push({
				texto: 'Nuevo buzón',
				icono: 'fa fa-plus',
				activo: true,
				callback: () => {
					this.editarBuzon = {
						padre: {
							nombre: 'RAÍZ'
						},
						buzon: {
							ID_buzon: null,
							nombre: null,
							BuzonPadre: null
						}
					}
				}
			})
			this.$store.commit('contextual/mostrar', menu)
		},
		insertar (e) {
			this.$emit('insertar', e)
		},
		reproducir (e) {
			this.$emit('reproducir', e)
		}
	}
}
</script>

<style scoped>
	.contenedor {
		display: flex;
		flex-grow: 1;
		align-content: stretch;
		align-items: stretch;
		align-self: stretch;
		flex-direction: column;
	}
	.contenedor > .titulo {
		max-height: 30px;
		height: 30px;
		flex-basis: 0;
	}

	.contenedor > .arbol {
		flex-grow: 1;
		flex-basis: 0;
		overflow-y: auto;
		margin-bottom: 2px;
		border: 1px solid #e0e0e0;
		background-color: white;
	}

	.contenedor > .ficheros {
		flex-grow: 1;
		flex-basis: 0;
		overflow-y: auto;
		margin-top: 2px;
		border: 1px solid #e0e0e0;
		background-color: white;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/organizar-emisoras/vue/paginas/organizar/favoritos.vue